import React from "react";
import { connect } from "react-redux";
import LogoInverse from "../../../img/logo-inverse.svg";

const Success = () => {
    return (
        <div className="tw-min-h-screen tw-flex tw-flex-col tw-relative tw-overflow-hidden tw-bg-gradient-to-br tw-from-theme-blue tw-to-theme-teal tw-font-nunito">
            <div className="tw-absolute tw-left-[-7rem] tw-bottom-[-3rem] tw-w-[30rem] tw-h-[30rem] tw-rounded-full tw-bg-theme-teal tw-blur-[80px] tw-pointer-events-none" aria-hidden="true" />

            <header className="tw-relative tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-8 md:tw-px-24 md:tw-py-14">
                <a href="https://prospectpath.com/" target="_blank" rel="noreferrer">
                    <img src={LogoInverse} alt="Prospect Path" className="tw-h-4 md:tw-h-[17px]" />
                </a>

                <div className="tw-flex tw-items-center tw-gap-5">
                    <span className="tw-hidden sm:tw-inline tw-text-white tw-text-base">Already have an account?</span>
                    <a
                        href="/login"
                        className="tw-bg-white tw-text-gray-800 tw-text-base tw-font-semibold tw-rounded-lg tw-px-4 tw-py-2 tw-no-underline hover:tw-no-underline hover:tw-bg-gray-100"
                    >
                        Log in
                    </a>
                </div>
            </header>

            <main className="tw-relative tw-flex tw-flex-1 tw-items-start tw-justify-center tw-px-4 tw-pb-16 md:tw-pt-6">
                <div className="tw-w-full tw-max-w-[52rem] tw-bg-white/75 tw-rounded-lg tw-px-6 tw-py-16 md:tw-py-24">
                    <div className="tw-max-w-[34rem] tw-mx-auto tw-text-center">
                        <h2 className="tw-text-2xl tw-font-semibold tw-text-gray-800 tw-mt-0 tw-mb-8">
                            We have received your request
                        </h2>

                        <p className="tw-text-base tw-text-gray-700 tw-leading-relaxed tw-mt-0 tw-mb-4">
                            Once our team has reviewed your request, you will receive an email confirmation with
                            further details on the progress of your account creation.
                        </p>
                        <p className="tw-text-base tw-text-gray-700 tw-leading-relaxed tw-m-0">
                            If you have any further queries, please reach out to our team directly at{" "}
                            <a
                                href="mailto:customerteam@prospectpath.com"
                                className="tw-text-gray-800 tw-font-semibold tw-underline hover:tw-text-theme-blue"
                            >
                                customerteam@prospectpath.com
                            </a>
                            .
                        </p>
                    </div>
                </div>
            </main>
        </div>
    )
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Success);
